import React from "react";
import SiteFooter from "@/components/SiteFooter";
import { PsyGestionIcon } from "@/components/PsyGestionLogo";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  muted: "#6B85A3",
  border: "#D6E4F0",
  white: "#FFFFFF",
};

const cards = [
  {
    icon: "🔒",
    title: "Données sécurisées",
    desc: "Vos données financières sont hébergées en Europe sur des serveurs conformes RGPD. Elles ne sont jamais vendues ni partagées.",
  },
  {
    icon: "🎯",
    title: "Estimations honnêtes",
    desc: "Tous nos calculs sont des estimations basées sur les taux officiels 2026. Ils ne remplacent pas un expert-comptable.",
  },
  {
    icon: "🛠️",
    title: "Produit en évolution",
    desc: "PsyGestion est en phase bêta active. Vos retours influencent directement les prochaines fonctionnalités.",
  },
];

export default function About() {
  return (
    <div style={{ fontFamily: "'Inter', system-ui, -apple-system, sans-serif", backgroundColor: C.white, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Nav */}
      <nav style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}`, padding: "16px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto", display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
            <PsyGestionIcon size={28} />
            <span style={{ fontWeight: 700, fontSize: 16, color: C.navy }}>PsyGestion</span>
          </a>
        </div>
      </nav>

      <main style={{ flex: 1, padding: "64px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          {/* Section 1 */}
          <h1 style={{ fontSize: 28, fontWeight: 800, color: C.navy, marginBottom: 20 }}>
            Qui sommes-nous ?
          </h1>
          <p style={{ color: C.muted, fontSize: 15, lineHeight: 1.8, marginBottom: 56 }}>
            PsyGestion est un outil indépendant créé pour aider les psychologues libéraux à mieux
            comprendre et gérer leurs finances professionnelles. Nous ne sommes pas un cabinet
            comptable — nous sommes des développeurs qui ont vu des psychologues proches perdre des
            milliers d'euros chaque année faute d'information fiscale claire et accessible.
          </p>

          {/* Section 2 */}
          <h2 style={{ fontSize: 20, fontWeight: 800, color: C.navy, marginBottom: 24 }}>
            Ce que nous promettons
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: 20,
              marginBottom: 56,
            }}
          >
            {cards.map((c) => (
              <div
                key={c.title}
                style={{
                  backgroundColor: "#F7FAFE",
                  border: `1px solid ${C.border}`,
                  borderRadius: 14,
                  padding: "24px 20px",
                }}
              >
                <div style={{ fontSize: 28, marginBottom: 10 }}>{c.icon}</div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: C.navy, marginBottom: 8 }}>
                  {c.title}
                </h3>
                <p style={{ fontSize: 13, color: C.muted, lineHeight: 1.7 }}>{c.desc}</p>
              </div>
            ))}
          </div>

          {/* Section 3 */}
          <h2 style={{ fontSize: 20, fontWeight: 800, color: C.navy, marginBottom: 12 }}>
            Nous contacter
          </h2>
          <p style={{ color: C.muted, fontSize: 14, marginBottom: 16 }}>
            Une question, un bug, une suggestion ?
          </p>
          <a
            href="mailto:contact@freedomarchitect.io"
            style={{ color: C.teal, fontWeight: 700, fontSize: 15, display: "block", marginBottom: 20 }}
          >
            contact@freedomarchitect.io
          </a>
          <a
            href="mailto:contact@freedomarchitect.io"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "12px 24px",
              borderRadius: 12,
              border: `2px solid ${C.teal}`,
              backgroundColor: "transparent",
              color: C.teal,
              fontWeight: 700,
              fontSize: 15,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Envoyer un message →
          </a>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
